export default {
  stSessionId: null,
  user: null,
  role: {
    isSuperAdmin: true,
    isAccountAdmin: true,
    master: true,
    permissions: { canViewPermissions: true },
  },
  requestStatus: 'loading',
  firebaseConnected: false,
  firebaseUser: null,
};
